module.exports = __webpack_public_path__ + "assets/img/img_1.d3e9f65b.png";